const videoSliders = [...document.querySelectorAll('.js-videoSlider')];

if (videoSliders.length) {
    videoSliders.forEach(videoSlider => {
        const mediaStages = [...videoSlider.querySelectorAll('.videoSlider__mediaStage')];
        const videoSliderItems = [...videoSlider.querySelectorAll('.js-videoSliderItem')];

        // Function to initialize play/pause buttons for a given media stage
        const initializePlayPauseButtons = (stage) => {
            const playButton = stage.querySelector('.video_control-play');
            const pauseButton = stage.querySelector('.video_control-pause');
            const iframe = stage.querySelector('.js-videoSliderIframe');
            const overlay = stage.querySelector('.videoSlider__videoContainerOverlay');

            if (iframe && playButton && pauseButton) {
                // Remove existing event listeners to prevent duplication
                playButton.replaceWith(playButton.cloneNode(true));
                pauseButton.replaceWith(pauseButton.cloneNode(true));

                // Reassign the variables to the new nodes
                const newPlayButton = stage.querySelector('.video_control-play');
                const newPauseButton = stage.querySelector('.video_control-pause');

                // Add event listeners to the play/pause buttons
                newPlayButton.addEventListener('click', () => {
                    iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                    newPlayButton.classList.add('hidecontrol');
                    newPauseButton.classList.remove('hidecontrol');
                    if (overlay) {
                        overlay.classList.add('hidden');
                    }
                });

                newPauseButton.addEventListener('click', () => {
                    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    newPlayButton.classList.remove('hidecontrol');
                    newPauseButton.classList.add('hidecontrol');
                    if (overlay) {
                        overlay.classList.remove('hidden');
                    }
                });

                // Initially, set play button visible and pause button hidden
                newPlayButton.classList.remove('hidecontrol');
                newPauseButton.classList.add('hidecontrol');
                if (overlay) {
                    overlay.classList.remove('hidden');
                }
            }
        };

        // Hide all media stages except the first one (default display)
        mediaStages.forEach((stage, index) => {
            if (index !== 0) {
                stage.style.display = 'none';
            } else {
                // Initialize play/pause buttons for the first visible stage
                initializePlayPauseButtons(stage);
            }
        });

        videoSliderItems.forEach((videoSliderItem, index) => {
            videoSliderItem.addEventListener('click', () => {
                // Hide all media stages and pause all videos
                mediaStages.forEach(stage => {
                    stage.style.display = 'none';
                    const iframe = stage.querySelector('.js-videoSliderIframe');
                    const overlay = stage.querySelector('.videoSlider__videoContainerOverlay');
                    if (iframe) {
                        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    }
                    if (overlay) {
                        overlay.classList.remove('hidden');
                    }
                });

                // Show the corresponding media stage based on the index of the clicked thumbnail
                const currentStage = mediaStages[index];
                currentStage.style.display = 'block';

                // Initialize play/pause buttons for the newly visible stage
                initializePlayPauseButtons(currentStage);
            });
        });
    });
}
